/** Human-readable category shown under a file's name (e.g. "Presentation" for .pptx). */
const FILE_TYPE_LABELS: Record<string, string> = {
    xlsx: 'Spreadsheet',
    xls: 'Spreadsheet',
    xlsm: 'Spreadsheet',
    xlsb: 'Spreadsheet',
    csv: 'Spreadsheet',
    docx: 'Document',
    doc: 'Document',
    pdf: 'PDF',
    pptx: 'Presentation',
    ppt: 'Presentation',
    png: 'Image',
    jpg: 'Image',
    jpeg: 'Image',
    gif: 'Image',
    svg: 'Image',
    webp: 'Image',
    mp4: 'Video',
    mov: 'Video',
    avi: 'Video',
    mp3: 'Audio',
    wav: 'Audio',
    txt: 'Text',
    json: 'JSON',
    xml: 'XML',
    zip: 'Archive',
    rar: 'Archive'
};

/** Extracts a lowercase file extension (no dot) from a filename, e.g. "Report.PDF" -> "pdf". */
export function getFileExtension(fileName?: string): string | null {
    if (!fileName) return null;
    const ext = fileName.toLowerCase().split('.').pop() || '';
    return ext || null;
}

/** Maps a file extension to a human-readable type label, e.g. "pptx" -> "Presentation". */
export function getFileTypeLabel(extension?: string | null): string {
    if (!extension) return 'File';
    return FILE_TYPE_LABELS[extension.toLowerCase()] || 'File';
}
